import { createApiAction } from '@app/packages/api/utils'
import type { ApiUserConsent } from '@app/packages/api/v2/types/entities'
import type { GetUserConsentsQuery, PostUserConsentsBulkRequest } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getUserConsents = (query?: GetUserConsentsQuery) =>
  createApiAction('getUserConsents', dispatch => dispatch<{ data: ApiUserConsent[] }>({ method: 'GET', endpoint: v2Path('/api/v2/user_consents', query) }))

export const postUserConsentsBulk = (request: PostUserConsentsBulkRequest) =>
  createApiAction('postUserConsentsBulk', dispatch =>
    dispatch<{ data: ApiUserConsent[] }>({ method: 'POST', endpoint: '/api/v2/user_consents/bulk', body: JSON.stringify(request) })
  )
